<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 数据字典配置
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <!-- <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm> -->
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="字典类型名">
              <el-input placeholder="请输入字典类型名称" v-model="seefrom.name"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/dictionaryType/queryList"
            :parent="self"
            :config="config"
            :other="other"
            ref="dataDictionary"
          >
            <template slot="last">
              <el-table-column label="操作" width="500px" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="see(scope.row)"
                    >查看</el-link
                  >
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.row)"
                    >编辑</el-link
                  >
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteData(scope.row)"
                    >删除</el-link
                  >
                  <el-link
                    icon="iconfont iconadd"
                    type="text"
                    size="small"
                    @click="contact(scope.row)"
                    >关联字典</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="字典类型名称" prop="name">
              <el-input v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="字典类型标识" prop="dicKey">
              <el-input v-model.trim="addEquipment.dicKey"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="addEquipment.remark"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="seeBtn">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog
          class="cust_dialog"
          title="数据字典信息"
          :visible.sync="dialogdeVisible"
          width="62%"
          :close-on-click-modal="false"
        >
          <div class="formtab">
            <el-form ref="dynamicValidateForm" class="demo-dynamic">
              <el-form-item style="display:inline-block;width:80px;"></el-form-item>
              <el-form-item
                :label="'字典名称'"
                style="display:inline-block;margin-bottom:0px;width:170px"
              ></el-form-item>
              <el-form-item
                :label="'字典数据'"
                style="display:inline-block;margin-bottom:0px;width:170px"
              ></el-form-item>
              <el-form-item
                :label="'备注'"
                style="display:inline-block;margin-bottom:0px;width:170px"
              ></el-form-item>

              <el-form-item
                v-for="(domain, index) in dynamicValidateForm"
                :label="'数据字典'"
                :key="domain.key"
                :prop="dynamicValidateForm.name"
                :rules="[{ required: true, message: '字典名称不能为空', trigger: 'blur' }]"
                style="display:inline-block"
              >
                <el-input class="d_name" v-model="domain.name" placeholder="字典名称"></el-input>

                <el-form-item
                  :prop="'dynamicValidateForm.' + index + '.value'"
                  style="display:inline-block"
                >
                  <el-input class="d_data" v-model="domain.value" placeholder="字典数据"></el-input>
                </el-form-item>

                <el-form-item
                  :prop="'dynamicValidateForm.' + index + '.remark'"
                  style="display:inline-block"
                >
                  <el-input class="d_remark" v-model="domain.remark" placeholder="备注"></el-input>
                </el-form-item>
                <el-button type="primary" @click.prevent="saveDomain(domain)">提交</el-button>
                <el-button type="danger" @click.prevent="removeDomain(domain)">删除</el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="d_add_data" type="success" @click="addDomain"
                  >新增数据字典</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { dt, obj2urlsp } from 'utils'

  export default {
    data() {
      return {
        rules: {
          name: [{ required: true, message: '请输入字典类型名称', trigger: 'blur' }],
          dicKey: [{ required: true, message: '请输入字典类型标识', trigger: 'blur' }]
        },
        title: '',
        tabName: 'jsgl',
        showTable: true,
        other: {},
        seeBtn: true,
        displayForm: false,
        dialogdeVisible: false,
        dynamicValidateForm: [],
        seefrom: {
          name: ''
        },
        addEquipment: {
          name: '',
          dicKey: '',
          remark: ''
        }
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'name',
            label: '字典类型名称'
          },
          {
            prop: 'remark',
            label: '备注'
          }
          // {
          //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
          //   label: "随便"
          // }
        ]
      },
      dt() {
        return dt.map(({ label }) => label)
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable')
    },
    methods: {
      //搜索
      subSeefrom() {
        this.other = this.seefrom
        this.$nextTick(this.$refs.dataDictionary.getData)
      },
      //重置
      reset() {
        this.seefrom.name = ''
      },
      //查看
      see(row) {
        this.title = '查看数据字典信息'
        this.displayForm = true
        this.$axiosget('operation/dictionaryType/queryById', {
          params: {
            id: row.id
          }
        }).then(res => {
          if (true) {
            this.addEquipment.name = res.data.data.name
            this.addEquipment.remark = res.data.data.remark
            this.addEquipment.dicKey = res.data.data.dicKey
            this.seeBtn = false
          }
        })
        if (this.$refs['addEquipment']) this.$refs['addEquipment'].clearValidate()
      },
      //编辑
      edit(row) {
        this.title = '编辑数据字典'
        this.displayForm = true
        this.seeBtn = true
        this.$axiosget('operation/dictionaryType/queryById', {
          params: {
            id: row.id
          }
        }).then(res => {
          if (true) {
            this.state = 2
            this.id = row.id
            this.addEquipment.name = res.data.data.name
            this.addEquipment.remark = res.data.data.remark
            this.addEquipment.dicKey = res.data.data.dicKey
          }
        })
        if (this.$refs['addEquipment']) this.$refs['addEquipment'].clearValidate()
      },
      //新增
      addnew() {
        this.title = '新增数据字典'
        this.state = 1
        this.displayForm = true
        this.seeBtn = true
        this.addEquipment = {
          name: '',
          remark: '',
          dicKey: ''
        }
        this.$refs['addEquipment'].clearValidate()
      },
      addDomain() {
        this.dynamicValidateForm.push({
          name: '',
          value: '',
          remark: '',
          dicTypeId: this.id
        })
      },
      //确认
      submitAdd() {
        this.$refs['addEquipment'].validate(valid => {
          if (valid) {
            if (this.state === 1) {
              this.$axiosput('operation/dictionaryType/add', this.addEquipment).then(res => {
                if (true) {
                  this.displayForm = false
                  this.subSeefrom()
                  let loading = Loading.service({})
                  loading.close()
                }
              })
            } else if (this.state === 2) {
              this.$axiospost('operation/dictionaryType/updateById', {
                id: this.id,
                dicKey: this.addEquipment.dicKey,
                name: this.addEquipment.name,
                remark: this.addEquipment.remark
              }).then(res => {
                if (true) {
                  this.displayForm = false
                  this.subSeefrom()
                }
              })
            }
          }
        })
      },
      //删除
      deleteData(row) {
        this.id = row.id
        //console.log(row.id,"id")
        this.$confirm('是否删除该数据字典?', '删除操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$axiosdelete('operation/dictionaryType/deleteById', {
              params: {
                id: row.id
              }
            }).then(res => {
              if (true) {
                this.subSeefrom()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            })
          })
          .catch(() => {})
      },
      //关联字典
      contact(row) {
        this.dialogdeVisible = true
        this.id = row.id
        this.$axiosget('operation/dictionaryType/queryById', {
          params: {
            id: row.id
          }
        }).then(res => {
          if (true) {
            this.dynamicValidateForm = res.data.data.list
          }
        })
      },
      removeDomain(domain) {
        this.$axiosdelete('operation/dictionaryData/deleteById', {
          params: {
            id: domain.id
          }
        }).then(res => {
          var index = this.dynamicValidateForm.indexOf(domain)
          if (index !== -1) {
            this.dynamicValidateForm.splice(index, 1)
          }
        })
      },
      saveDomain(domain) {
        //console.log(domain,"domain")
        //console.log(domain.id)
        if (domain.name === domain.value) {
          this.$message.error('字典名称和字典数据不能相同')
          return
        }
        if (!domain.id) {
          let params = {
            name: domain.name,
            value: domain.value,
            remark: domain.remark,
            dicTypeId: this.id
          }
          this.$axiospost('operation/dictionaryData/add', params).then(res => {
            if (true) {
              this.$message.success('保存成功')
              this.dialogdeVisible = false
            }
          })
        } else {
          this.$axiospost('operation/dictionaryData/update', {
            id: domain.id,
            name: domain.name,
            value: domain.value,
            remark: domain.remark,
            dicTypeId: domain.dicTypeId
          }).then(res => {
            if (true) {
              this.$message.success('保存成功')
            }
          })
        }
      }
    }
  }
</script>

<style lang="less">
  .content {
    .w_normalNav {
      padding-top: 10px;
      height: 52px;
      position: absolute;
      top: -52px;
      right: 32px;
      z-index: 99;
    }
    .tabLv3 {
      .cust_dialog {
        .d_name {
          width: 160px;
          margin-left: 10px;
        }
        .d_data {
          width: 160px;
        }
        .d_remark {
          width: 250px;
        }
        .d_add_data {
          margin-left: 80px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/configuration/dataDictionary.vue